module.exports = __webpack_public_path__ + "static/media/2021-ehrenmitglieder.76eac4d2.jpg";